'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

export interface TicketsState {
  page: number;
}

const initialState: TicketsState = {
  page: 1,
};

export const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    setTicketsPage: (state, action: PayloadAction<{ page: number }>) => {
      const { page } = action.payload;
      return {
        ...state,
        page: page,
      };
    },
  },
});

export const { setTicketsPage } = ticketsSlice.actions;
export const ticketPageSelector = (state: RootState) => state.tickets.page;
export default ticketsSlice.reducer;
